export default{
    pageTitle: {
        home: 'aCloud',
        dietPlans: 'Διατροφικά Πλάνα – aCloud',
        recipes: 'Συνταγές – aCloud',
        foods: 'Τρόφιμα – aCloud',
        meals: 'Πρότυπα Γευμάτων – aCloud',
        listing: 'Καταχώρηση – aCloud',
        user: 'Προφίλ Χρήστη – aCloud',
        myListings: 'Οι Καταχωρήσεις μου – aCloud',
    },

    user: 'Χρήστης',
    profile: {
        subtitle: 'Εξερεύνηση του προφίλ του χρήστη',
        listings: {
            title: 'Οι καταχωρήσεις μου',
            subtitle: 'Δες και διάγραψε τις καταχωρήσεις σου από το athlisis cloud.'

        },
        edit: 'Επεξεργασία καταχώρησης',
        empty: {
            plans: 'Δεν έχεις μοιραστεί κανένα διατροφικό πλάνο ακόμα',
            recipes: 'Δεν έχεις μοιραστεί καμία συνταγή ακόμα',
            foods: 'Δεν έχεις μοιραστεί κανένα τρόφιμο ακόμα',
            subtitle: 'Μοιράσου τη δουλειά σου με την κοινότητα και βοήθησε άλλους διατροφολόγους.',
        },
    },
    ordering: {
        label: 'Ταξινόμηση',
        latest: 'Πιο πρόσφατα',
        oldest: 'Πιο παλιά',
        downloads: 'Περισσότερα downloads',
        likes: 'Περισσότερα likes'
    },
    sidebar: {
        categories: 'Κατηγορίες προτύπων',
        home: 'Αρχική',
        plans: 'Διατροφικά πλάνα',
        recipes: 'Συνταγές',
        profile: 'Προφίλ',
        listings: 'Οι καταχωρήσεις μου',
        myProfile: 'Το προφίλ μου',
    },
    home: {
        title: 'Καλωσόρισες στο Athlisis Cloud 👋',
        subtitle: 'Ένα μέρος όπου όλοι οι διατροφολόγοι του athlisis μπορούν να μοιράζονται εύκολα διατροφικά πλάνα, τρόφιμα, συνταγές, πρότυπα γεύματα.',
    },
    plans: {
        title: 'Διατροφικά πλάνα',
        subtitle: 'Εξερευνήστε & μοιραστείτε διατροφικά πλάνα. Χρησιμοποιήστε τις ετικέτες και την αναζήτηση\n' +
            'για ακόμα πιο εξατομικευμένα αποτελέσματα',
    },
    meals: {
        title: 'Coming soon',
        subtitle: 'Εξερευνήστε διατροφικά πλάνα κάθε είδους. Χρησιμοποιήστε τις ετικέτες και την αναζήτηση\n' +
            'για ακόμα πιο εξατομικευμένα αποτελέσματα'
    },
    searchByName: 'Αναζητήστε με βάση το όνομα...',
    tags: 'Αναζήτηση ανά ετικέτα',
    recipes: {
        title: 'Συνταγές',
        subtitle: 'Εξερευνήστε & μοιραστείτε συνταγές. Χρησιμοποιήστε τις ετικέτες και την αναζήτηση\n' +
            '    για ακόμα πιο εξατομικευμένα αποτελέσματα',
    },
    foods: {
        title: 'Τρόφιμα',
        subtitle: 'Εξερευνήστε τρόφιμα που έχουν δημιουργηθεί κατά την προσθήκη συνταγών, γευμάτων'
    },
    popularPlans: 'Δημοφιλή διατροφικά πλάνα',
    noPlans: 'Δεν βρέθηκαν διατροφικά πλάνα',
    popularRecipes: 'Δημοφιλείς συνταγές',
    noRecipes: 'Δεν βρέθηκαν συνταγές',
    noFoods: 'Δεν βρέθηκαν τρόφιμα',
    downloads: 'Συνολικές λήψεις',
    likes: 'Συνολικά Likes',
    back: 'Επιστροφή',

    discussion: 'Συζήτηση / σχόλια',
    plan: {
        tabs: {
            0: 'Διατροφικό πλάνο',
            1: 'Ανάλυση πλάνου',
        }
    },
    save: 'Αποθήκευση στα πρότυπά μου',
    saved: 'Αποθηκεύτηκε επιτυχώς στα πρότυπα.',
    comment: 'Το σχόλιό σου',
    noComments: 'Δεν υπάρχουν σχόλια ακόμα',
    noCommentsText: 'Γράψε το πρώτο σχόλιο.',
    noPopularText: 'Οι πιο δημοφιλείς καταχωρήσεις της κοινότητας θα εμφανίζονται εδώ.',
    noPopularUserText: 'Ό,τι μοιραστεί ο χρήστης με την κοινότητα θα εμφανίζεται εδώ.',
    commentDisclaimer: 'Απαγορεύονται τα μηνύματα που έχουν ως αποτέλεσμα τη δημιουργία έριδων / κακής ατμόσφαιρας.<br/> Σεβάσου όλα τα μέλη ακόμη κι αν διαφωνείς. Σεβάσου όλα τα πρόσωπα, φυσικά ή νομικά, ακόμη κι αν σε έχουν βλάψει.<br>\n' +
        '            <strong>Μη τήρηση των όρων μπορεί να οδηγήσει σε αποκλεισμό από το Athlisis Cloud.</strong>',
    average: {
        proteins: 'Μέσος όρος πρωτεϊνών  <br>(μόνο ημέρες με τρόφιμα)',
        carbs: 'Μέσος όρος υδατανθράκων  <br>(μόνο ημέρες με τρόφιμα)',
        fats: 'Μέσος όρος λιπών  <br>(μόνο ημέρες με τρόφιμα)',
        kcal: 'Μέσος όρος ενέργειας <br>(μόνο ημέρες με τρόφιμα)'
    },
    dpSuccess: 'Το διατροφικό πλάνο αποθηκεύτηκε επιτυχώς! Μπορείτε να το βρείτε στα "πρότυπα" διατροφικά πλάνα σας!',
    recipeSuccess: 'Η συνταγή αποθηκεύτηκε επιτυχώς!',
    saveTemplateModal: {
        title: 'Θέλετε σίγουρα να κάνετε αποθήκευση;',
        body: '<p>Εάν προχωρήσετε με την αντιγραφή, θα προστεθούν <strong>{count} τρόφιμα</strong> στη λίστα τροφίμων σας από την cloud βιβλιοθήκη (εάν δεν υπάρχουν ήδη).</p>' +
            '<p>Τα τρόφιμα που θα προστεθούν είναι:<br> <strong>{foods}</strong></p>',
        okText: 'Αποθήκευση προτύπου'
    }

}
